import { Stack } from '@shipt/design-system-layouts'
import { routes } from '@shared/constants/routes'
import { useCartShoppingCartLines } from '@/features/shop/services/Cart/hooks'
import { GuestHasCartParam } from '@/features/shared/constants/ungatedParams'
import { ButtonLink } from '@/features/shared/elements/Link/Buttons'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { usePathWithSearch } from '@/features/shared/hooks/routes/usePathWithSearch'

type Props = {
  className?: string
  isHeader?: boolean
  holidayGHP?: boolean
}

export const AccountCreationButtons = ({ className, isHeader, holidayGHP }: Props) => {
  const pathWithSearch = usePathWithSearch()
  const encodedFullPath = encodeURIComponent(pathWithSearch)
  const cartProducts = useCartShoppingCartLines()
  const isUngatedFlow = cartProducts.length
  const buttonHrefSignup = isUngatedFlow
    ? `${routes.SIGN_UP.url}?${GuestHasCartParam}&from=${encodedFullPath}`
    : `${routes.SIGN_UP.url}?next=${encodedFullPath}`

  const buttonHrefSignin = isUngatedFlow
    ? `${routes.LOGIN.url}?${GuestHasCartParam}&from=${encodedFullPath}`
    : `${routes.LOGIN.url}?next=${encodedFullPath}`

  const handleOnClickLink = (content: 'sign_in' | 'sign_up') =>
    trackElementClicked({
      type: 'link',
      content,
      display_sublocation: isHeader ? 'header' : 'drawer',
    })
  return (
    <Stack
      flexShrink={0}
      direction={isHeader ? 'row' : 'column'}
      align="center"
      spacing={isHeader ? 'sm' : 'md'}
      className={className}
      display={isHeader ? 'flex' : undefined}
    >
      <ButtonLink
        variant="secondary"
        surface={holidayGHP ? 'inverse' : undefined}
        href={buttonHrefSignin}
        fullWidth={!isHeader}
        nativeLink
        size={isHeader ? { base: 'sm', sm: 'md' } : 'lg'}
        onClick={() => handleOnClickLink('sign_in')}
      >
        Sign in
      </ButtonLink>
      <ButtonLink
        href={buttonHrefSignup}
        fullWidth={!isHeader}
        variant={holidayGHP ? 'primary' : undefined}
        surface={holidayGHP ? 'inverse' : undefined}
        nativeLink
        size={isHeader ? { base: 'sm', sm: 'md' } : 'lg'}
        onClick={() => handleOnClickLink('sign_up')}
      >
        Sign up
      </ButtonLink>
    </Stack>
  )
}
